import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const serifFont = { fontFamily: "'Crimson Pro', Georgia, serif" };
const monoFont  = { fontFamily: "'DM Mono', monospace" };

const NotFoundPage: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-[#f0f2f5]" style={{ fontFamily: "'Outfit', sans-serif" }}>
    <style>{`@import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@400;600&family=DM+Mono:wght@400;500&family=Outfit:wght@400;500;600&display=swap');`}</style>
    <Navbar />
    <main className="flex-1 flex items-center justify-center px-6 py-24">
      <div className="text-center max-w-lg">
        <p style={monoFont} className="text-[#FFB81C] text-xs tracking-[0.18em] uppercase mb-3">Error 404</p>
        <h1 style={serifFont} className="text-6xl font-light text-[#001f5b] mb-4">Page not found</h1>
        <p className="text-gray-500 mb-8">This page doesn't exist or may have moved.</p>
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded bg-[#003594] text-white font-semibold text-sm hover:bg-[#00276e] transition-colors">
          ← Back to the App Hub
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;